import * as React from 'react'
import styled from 'styled-components'
import { useStore } from 'effector-react/ssr'
import { useParams } from 'react-router'
import { debounce } from 'debounce'
import { useHistory } from 'react-router-dom'
import ReactMarkdown from 'react-markdown'
import rehypeRaw from 'rehype-raw'
import { Social } from '@ui/social'
import { Devices } from '@styles'
import newsCover from '@assets/images/single-news-cover.jpg'
import newsCoverMobile from '@assets/images/news-cover-mobile.jpg'
import { matchMedia, MediaSource } from '@lib/image-media'
import BackIcon from '@assets/icons/back.svg'
import { isClientSide } from '@lib/ssr'
import { paths } from '@pages/paths'
import { useBackgroundOnKroll } from '@lib/use-on-krol'
import { Layout } from '@ui/layout'
import * as model from '../model'
import styles from './news-open.module.scss'

const newsMedia: MediaSource<string>[] = [
  { mediaQuery: Devices.laptop, source: newsCover },
  { mediaQuery: Devices.mobileS, source: newsCoverMobile },
]

interface ParamsType {
  id: string
}

export const NewsOpenPage = () => {
  const [pageCover, setPageCover] = React.useState('')
  const showBackground = useBackgroundOnKroll()

  const params = useParams<ParamsType>()
  const history = useHistory()
  const newsList = useStore(model.$newsList)

  const onResize = React.useCallback(
    debounce(() => setPageCover(matchMedia(newsMedia, '')), 100),
    [],
  )

  React.useEffect(() => {
    if (isClientSide()) {
      setPageCover(matchMedia(newsMedia, ''))
      window.addEventListener('resize', onResize)
    }

    return () => {
      if (isClientSide()) {
        window.removeEventListener('resize', onResize)
      }
    }
  }, [])

  const imageUrl = `url(${pageCover})`

  const news = newsList[newsList.findIndex((news) => news.id === Number(params.id))]

  const onBackClick = () => history.push(paths.news())

  console.log(news ? news.fullDescription : 'empty')

  return (
    <Layout className={styles.newsOpen} showBorder={showBackground}>
      <NewsCover style={{ backgroundImage: imageUrl }} />

      <div>
        {news && (
          <News>
            <div style={{ position: 'relative' }}>
              <div onClick={onBackClick}>
                <BackButton />
              </div>

              <Title>{news.title}</Title>
            </div>
            <Date>{news.date}</Date>
            <Description>
              <ReactMarkdown rehypePlugins={[rehypeRaw]} children={news.fullDescription} />
            </Description>
            {news.content && <Preview src={news.content} />}
          </News>
        )}
      </div>

      <SocialWrapper>
        <Social />
      </SocialWrapper>
    </Layout>
  )
}

const NewsCover = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: -1;

  width: 100vw;
  height: 100vh;

  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
`

const BackButton = styled(BackIcon)`
  cursor: pointer;
  position: absolute;

  top: -30px;

  @media screen and ${Devices.laptop} {
    left: -40px;
    top: 8px;
  }
`

const SocialWrapper = styled.div`
  display: none;

  @media screen and ${Devices.laptop} {
    display: block;
  }
`

const News = styled.div`
  padding: 30px;

  margin-top: 30px;

  @media screen and ${Devices.laptop} {
    margin: 18px 175px 75px 175px;
  }

  @media screen and ${Devices.desktopS} {
    margin: 18px 175px 75px 275px;
  }
`

const Date = styled.div`
  margin-bottom: 25px;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 23px;
  color: #828282;
`

const Title = styled.div`
  margin-bottom: 30px;
  font-family: Raleway;
  font-style: normal;
  font-weight: bold;
  font-size: 25px;
  line-height: 29px;
`

const Description = styled.div`
  margin-bottom: 30px;
  font-family: Raleway;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 21px;
`

const Preview = styled.img`
  width: 100%;
  height: 100%;
`
